import { render, staticRenderFns } from "./SiteAccessError.vue?vue&type=template&id=ee8a26d8&scoped=true&"
import script from "./SiteAccessError.vue?vue&type=script&lang=js&"
export * from "./SiteAccessError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8a26d8",
  null
  
)

export default component.exports